import * as React from 'react';
const SvgGatsby = (props) => (
  <svg viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M34.354 0a34.354 34.354 0 1 0 34.353 34.354A34.454 34.454 0 0 0 34.354 0ZM15.21 53.496a26.642 26.642 0 0 1-7.851-18.65v-.252l26.748 26.748c-6.868-.24-13.715-2.697-18.897-7.846Zm25.285 7.36L8.108 28.462a26.978 26.978 0 0 1 48.097-10.051l-3.68 3.194a22.655 22.655 0 0 0-18.171-9.337 22.336 22.336 0 0 0-20.857 14.72l28.217 28.24a22.23 22.23 0 0 0 14.234-15.949H44.17v-4.925h17.177c0 12.76-9.08 23.56-20.852 26.502Z"
      fill="#639"
    />
  </svg>
);
export default SvgGatsby;
